module.exports = __webpack_public_path__ + "img/nobleriding_option_03.94bce85d.jpg";